import ClientError from './client';

export default class ValidationError extends ClientError {
  constructor(message, data) {

    //Parent constructor
    super(message, data, 422);
  }
}
